import enUs from 'date-fns/locale/en-US';
import * as React from 'react';
import * as ReactDatePickerNS from 'react-datepicker';
import type ReactDatePickerType from 'react-datepicker';

import { datePickerFormat } from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import styles from './styles.module.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DatePicker = ((ReactDatePickerNS as any).default?.default ?? (ReactDatePickerNS as any).default ?? ReactDatePickerNS) as typeof ReactDatePickerType;

interface OwnProps {
	selected: Date;
	onChange: (date: Date) => void;
}

const DailyPicker: React.FC<OwnProps> = ({ selected, onChange }) => {
	const datepickerRef = React.useRef<ReactDatePickerType>(null);

	const onSelect = React.useCallback((date: Nullable<Date>) => {
		onChange(date ?? new Date());
	}, [onChange]);

	const focusDatePicker = React.useCallback(() => {
		if (datepickerRef.current) {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(datepickerRef.current as any).input.focus();
		}
	}, [datepickerRef]);

	return (
		<div className={styles['date-picker-wrapper']}>
			<div className={styles['date-picker-wrapper__medium-picker']}>
				<DatePicker
					className={styles.picker}
					dateFormat={datePickerFormat(TimeFormat.DATE_ONLY)}
					disabledKeyboardNavigation
					dropdownMode="select"
					locale={enUs}
					onChange={onSelect}
					ref={datepickerRef}
					selected={selected}
					showMonthDropdown={true}
					showYearDropdown={true}
					todayButton="Today"
				/>
			</ div>
			<div className={styles['calendar-icon']} onClick={focusDatePicker}>
				<span className="icon-calendar" />
			</div>
		</div>
	);
};

export default React.memo(DailyPicker);
